import { render, staticRenderFns } from "./EventDetailsRescheduleForm.vue?vue&type=template&id=778e02fc&scoped=true&"
import script from "./EventDetailsRescheduleForm.vue?vue&type=script&lang=js&"
export * from "./EventDetailsRescheduleForm.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailsRescheduleForm.vue?vue&type=style&index=0&id=778e02fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778e02fc",
  null
  
)

export default component.exports